import { render, staticRenderFns } from "./ModalCreateTests.vue?vue&type=template&id=32d8ffb4&scoped=true"
import script from "./ModalCreateTests.vue?vue&type=script&lang=js"
export * from "./ModalCreateTests.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateTests.vue?vue&type=style&index=0&id=32d8ffb4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8ffb4",
  null
  
)

export default component.exports